import React from "react";
import { observer } from "mobx-react";
import { Link, PromiseMessage, PromiseRetry, X1LanguageSelect } from "lib/components";
import Select from 'react-select'
import { routes } from "pages/Routes";
import { TeacherStudentsSceneStore } from "../../classroom/teacher/TeacherStudentsSceneStore";
import { ReactNodeGenerator, HttpPromiseState } from "lib/helpers";
import { User } from "../../../domain";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { ClassroomLoaders } from "../../classroom/stores/classroom-loaders";
import { StudentPerformanceItem } from "../../classroom/models/classroom-models";
import { httpClient } from "domain/utils/httpClient";

interface TeacherDashboardStats {
  TotalStudents: number;
  TotalLessons: number;
}

const options = [
  { 
    value: 'English',
    label: 'English',
    optionAge: [
      { 
        value: 'Children',
        label: 'Children',
        optionLevel: [
          { value: 'Beginner', label: 'Beginner' },
          { value: 'Elementary', label: 'Elementary' },
        ]
      },
      { 
        value: 'Teen',
        label: 'Teen',
        optionLevel: [
          { value: 'Beginner', label: 'Beginner' },
          { value: 'Elementary', label: 'Elementary' },
          { value: 'Pre-intermediate', label: 'Pre-intermediate' },
          { value: 'Intermediate', label: 'Intermediate' },
          { value: 'Upper-intermediate', label: 'Upper-intermediate' },
          { value: 'Advanced', label: 'Advanced' },
        ]
      },
      {
        value: 'Adult',
        label: 'Adult',
        optionLevel: [
          { value: 'Beginner', label: 'Beginner' },
          { value: 'Elementary', label: 'Elementary' },
          { value: 'Pre-intermediate', label: 'Pre-intermediate' },
          { value: 'Intermediate', label: 'Intermediate' },
          { value: 'Upper-intermediate', label: 'Upper-intermediate' },
          { value: 'Advanced', label: 'Advanced' },
        ]
      }
    ]
  },
  { 
    value: 'Russian',
    label: 'Русский',
    optionAge: [
      { 
        value: 'Взрослые РКИ',
        label: 'Взрослые РКИ',
        optionLevel: [
          { value: 'Начинающий А1', label: 'Начинающий А1' },
          { value: 'Начинающий А2', label: 'Начинающий А2' },
          { value: 'Продолжающий В1', label: 'Продолжающий В1' },
        ]
      },
      { 
        value: 'Взрослые СНГ',
        label: 'Взрослые СНГ',
        optionLevel: [
          { value: 'Уровень А2', label: 'Уровень А2' },
        ]
      },
      {
        value: 'Азбука для малышей',
        label: 'Азбука для малышей',
        optionLevel: [
          { value: 'Уровень 1. Букварный период.', label: 'Уровень 1. Букварный период.' },
        ]
      }
    ]
  },
  { 
    value: 'Chinese',
    label: 'Китайский',
    optionAge: [
      { 
        value: 'Children',
        label: 'Children',
        optionLevel: [
          { value: 'Начинающий А1', label: 'Начинающий А1' },
          { value: 'Начинающий А2', label: 'Начинающий А2' },
          { value: 'Продолжающий В1', label: 'Продолжающий В1' },
        ]
      },
      { 
        value: 'Teen',
        label: 'Teen',
        optionLevel: [
          { value: 'Beginner', label: 'Beginner' },
          { value: 'Elementary', label: 'Elementary' },
          { value: 'Pre-intermediate', label: 'Pre-intermediate' },
          { value: 'Intermediate', label: 'Intermediate' },
          { value: 'Upper-intermediate', label: 'Upper-intermediate' },
          { value: 'Advanced', label: 'Advanced' },
        ]
      },
      {
        value: 'Adult',
        label: 'Adult',
        optionLevel: [
          { value: 'Beginner', label: 'Beginner' },
          { value: 'Elementary', label: 'Elementary' },
          { value: 'Pre-intermediate', label: 'Pre-intermediate' },
          { value: 'Intermediate', label: 'Intermediate' },
          { value: 'Upper-intermediate', label: 'Upper-intermediate' },
          { value: 'Advanced', label: 'Advanced' },
        ]
      }
    ]
  },
]

@observer
export class TeacherDashboard extends React.Component {
  store: TeacherStudentsSceneStore;
  
  state = {
    infoModal_isOpen: false,
    userName: null,
    userLevel: null,
    userLanguage: null,
    userTimeZone: null,
    userAge: null,
    language: options[0].value,
    age: options[0].optionAge[0].value,
    level: options[0].optionAge[0].optionLevel[0].value,
    optionsAge: options[0].optionAge,
    optionsLevel: options[0].optionAge[0].optionLevel,
    performanceData: [] as StudentPerformanceItem[],
    isLoadingPerformance: false,
    dashboardStats: null as TeacherDashboardStats | null,
  };

  constructor(props: any) {
    super(props);
    this.store = new TeacherStudentsSceneStore();  
  }

  componentDidMount() {
    this.loadPerformanceData();
    this.loadDashboardStats();
  }

  async loadDashboardStats() {
    try {
      const response = await httpClient.axios.get<TeacherDashboardStats>('/api/teacher/dashboard-stats');
      this.setState({ dashboardStats: response.data });
    } catch (error) {
      console.error('Failed to load dashboard stats:', error);
    }
  }

  async loadPerformanceData() {
    this.setState({ isLoadingPerformance: true });
    try {
      const response = await ClassroomLoaders.Teacher.getStudentsPerformance();
      this.setState({ performanceData: response.data });
    } catch (error) {
      console.error('Failed to load performance data:', error);
    } finally {
      this.setState({ isLoadingPerformance: false });
    }
  }
  
  *renderRowsStudents(
    resp: HttpPromiseState<User[]> | null
  ): ReactNodeGenerator {
    const res = resp?.value?.filter(r => r.Student?.Level?.AgeCategory?.Language?.Name === this.state.language && 
                                         r.Student?.Level?.AgeCategory?.Name === this.state.age &&
                                         r.Student?.Level?.Name === this.state.level);
    
    yield (
      <Modal
        key="AcceptModal"
        isOpen={this.state.infoModal_isOpen}
        size="lg"
        centered
        onOpened={this.onAcceptModalOpen}
      >
        <ModalHeader>
          <div>Student INFO</div>
        </ModalHeader>
        <ModalBody>
          <div className="block-content-inner">
            <div className="content-person">
              <div className="person-info">
                <p>
                  Name: {this.state.userName}
                </p>
                <p>
                  Language: {this.state.userLanguage}
                </p>
                <p>Age: {this.state.userAge}</p>
                <p>Level: {this.state.userLevel}</p>
                <p>Time Zone: {this.state.userTimeZone}</p>
              </div>
              <div className="person-avatar">
                <p>
                  <i className="fas fa-award"></i>
                </p>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-primary"
            onClick={this.onAcceptModalCancelBtnClick}
            value="test"
          >
            OK
          </button>
        </ModalFooter>
      </Modal>
    );
    if (res != null) {
      for (const r of res.slice(0, 3)) {
        // Find performance data for this student
        const perf = this.state.performanceData.find(p => p.StudentId === r.Id);
        const avgScore = perf && perf.ExamCount > 0 ? perf.AverageBal.toFixed(1) : '—';
        const examCount = perf?.ExamCount ?? 0;

        yield (
          <div className="block-content-inner" key={r.Id}>
            <div className="content-person">
              <div className="person-avatar">
                <p>
                  <i className="fas fa-award"></i>
                </p>
              </div>
              <div className="person-info">
                <button
                  type="button"
                  className="btn btn-ligth"
                  onClick={() => this.onAcceptBtnClick(r)}
                  style={{ margin: "-10px 15px -10px 0px" }}
                >
                  <p>
                    {r.FirstName} {r.LastName}
                  </p>
                </button>
                <span>
                  {r.Student?.Level?.AgeCategory?.Language?.Name} /{" "}
                  {r.Student?.Level?.AgeCategory?.Name} /{" "}
                  {r.Student?.Level?.Name} / {r.TimeZone?.UtcName}
                </span>
                <span style={{ display: 'block', marginTop: '4px', fontWeight: 500, color: '#5a67d8' }}>
                  <i className="fas fa-star" style={{ fontSize: '12px', marginRight: '4px' }}></i>
                  AVG: {avgScore} ({examCount} {examCount === 1 ? 'exam' : 'exams'})
                </span>
              </div>
            </div>
          </div>
        );
      }
    }
  }
  /**
   * Accept Modal Start
   */
  onAcceptBtnClick = (r: User) => {
    var self = this;
    this.setState({ infoModal_isOpen: true,  userName: r.FirstName + " " + r.LastName,
      userLevel: r.Student?.Level?.Name,
      userLanguage: r.Student?.Level?.AgeCategory?.Language?.Name,
      userTimeZone: r.TimeZone?.UtcName,
      userAge: r.Student?.Level?.AgeCategory?.Name, });
  };
  onAcceptModalOpen = () => {
    var self = this;
    this.setState({ student: null });
  };

  onAcceptModalCancelBtnClick = () => {
    this.setState({ infoModal_isOpen: false });
  };


  changeLanguage= (event: React.ChangeEvent<HTMLSelectElement>) =>  {
    event.preventDefault();
    var self = this;
    this.setState({ 
      optionsAge: options.find(item => item.value === event.target.value)?.optionAge,
      age: options.find(item => item.value === event.target.value)?.optionAge[0].value
    })
    this.setState({ 
      optionsLevel: options.find(item => item.value === event.target.value)?.optionAge[0].optionLevel,
      level: options.find(item => item.value === event.target.value)?.optionAge[0].optionLevel[0].value
    })
    this.setState({language: event.target.value });   
  }
  changeLevel= (event: React.ChangeEvent<HTMLSelectElement>) =>  {
    event.preventDefault();
    var self = this;
    this.setState({level: event.target.value });   
  }
  changeAge= (event: React.ChangeEvent<HTMLSelectElement>) =>  {
    event.preventDefault();
    var self = this;
    this.setState({ optionsLevel: this.state.optionsAge.find(item => item.value === event.target.value)?.optionLevel})
    this.setState({age: event.target.value });   
  }

  render() { 
     return (
      <div className="teacher-dashboard">
        <div className="t-Assignments">
          <div className="t-top">
            <div className="t-top-header">
              <p className="t-top-title">Teacher's Overview</p>
            </div>
            <div className="row ovrvw-container">
              <div className="col">
                <div className="ovrvw-block students">
                  <span>
                    <i className="fas fa-users"></i>
                  </span>
                  <h3>{this.state.dashboardStats?.TotalStudents ?? '—'}</h3>
                  <p>Total Students</p>
                </div>
              </div>
              <div className="col">
                <div className="ovrvw-block lessons">
                  <span>
                    <i className="fas fa-chalkboard-teacher"></i>
                  </span>
                  <h3>{this.state.dashboardStats?.TotalLessons ?? '—'}</h3>
                  <p>Total Lessons</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="teacher-blocks">
              <div className="teacher-block-header">
                <p className="t-top-title">Upcoming Lessons</p>
                <div className="option-timezone">(GMT+6)</div>
              </div>
              <div className="block-options">
                <div className="option-selects">
                  <select>
                    <option>English</option>
                    <option>Русский</option>
                    <option selected>Кыргызча</option>
                  </select>
                </div>
                <div className="option-selects">
                  <select>
                    <option selected>Children</option>
                    <option>Teen</option>
                    <option>Adult</option>
                  </select>
                </div>
                <div className="option-selects">
                  <select>
                    <option>Beginner</option>
                    <option>Pre-intermediate</option>
                    <option>Intermediate</option>
                    <option selected>Upper-intermediate</option>
                    <option>Advanced</option>
                  </select>
                </div>
              </div>
              <div className="block-content">
                <div className="block-content-inner">
                  <div className="content-person">
                    <div className="person-avatar">
                      <p>
                        <i className="fas fa-user-graduate"></i>
                      </p>
                    </div>
                    <div className="person-info">
                      <p>Oliver James</p>
                      <span>English / Teen / Upper-intermediate</span>
                    </div>
                  </div>
                  <div className="content-stage">
                    <h4>April 16 15:30</h4>
                    <p>
                      <span>6</span> / 26
                    </p>
                  </div>
                </div>
                <div className="block-content-inner">
                  <div className="content-person">
                    <div className="person-avatar">
                      <p>
                        <i className="fas fa-user-graduate"></i>
                      </p>
                    </div>
                    <div className="person-info">
                      <p>David Peter</p>
                      <span>English / Adult / Intermediate</span>
                    </div>
                  </div>
                  <div className="content-stage">
                    <h4>April 18 15:30</h4>
                    <p>
                      <span>2</span> / 13
                    </p>
                  </div>
                </div>
                <div className="block-content-inner">
                  <div className="content-person">
                    <div className="person-avatar">
                      <p>
                        <i className="fas fa-user-graduate"></i>
                      </p>
                    </div>
                    <div className="person-info">
                      <p>Lilly Paul</p>
                      <span>English / Children / Beginner</span>
                    </div>
                  </div>
                  <div className="content-stage">
                    <h4>April 20 15:30</h4>
                    <p>
                      <span>1</span> / 16
                    </p>
                  </div>
                </div>
                <div className="bottom-block">
                  <a href="#">View All Lessons</a>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="teacher-blocks">
              <div className="teacher-block-header">
                <p className="t-top-title">Students Performance</p>
              </div>
              <div className="block-options">             
                <div className="option-selects">  
                <select value={this.state.language} onChange={this.changeLanguage}>
                  {options.map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
                </div>                
                <div className="option-selects">
                <select value={this.state.age} onChange={this.changeAge}>
                  {this.state.optionsAge.map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
                </div>
                <div className="option-selects">
                <select value={this.state.level} onChange={this.changeLevel}>
                  {this.state.optionsLevel.map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>                 
                </div>
              </div>
              
              <div className="block-content">
                {this.state.isLoadingPerformance ? (
                  <div className="text-center py-3">
                    <i className="fas fa-spinner fa-spin"></i>
                  </div>
                ) : (
                  Array.from(this.renderRowsStudents(this.store.resultState))
                )}
                <div className="bottom-block">
                  <Link to={routes.TeacherStudents}>View All Students</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  componentWillUnmount() {
    this.store.dispose();
  }
}
